const normalizeEstadoName = (value = "") =>
  String(value).trim().toLowerCase().replace(/\s+/g, " ");

export const SENT_TO_CLIENT_ESTADO_NAMES = [
  "sent to client",
  "sent to cliente",
  "enviado a cliente",
];

export const SENT_TO_SUPPLIER_ESTADO_NAMES = [
  "sent to supplier",
  "sent to proveedor",
  "enviado a proveedor",
];

export const ARRIVED_TO_CLIENT_ESTADO_NAMES = [
  "arrived to client",
  "arrived to cliente",
  "llegado a cliente",
];

export const ARRIVED_TO_SUPPLIER_ESTADO_NAMES = [
  "arrived to supplier",
  "arrived to proveedor",
  "llegado a proveedor",
];

export const LEFT_WITH_CLIENT_ESTADO_NAMES = [
  "se queda en cliente",
  "se deja en cliente",
  "left with client",
  "stays with client",
];

export const ARRIVED_SDS_ESTADO_NAMES = ["arrived"];

export const findSentToClientEstado = (tiposEstado = []) =>
  tiposEstado.find((est) =>
    SENT_TO_CLIENT_ESTADO_NAMES.includes(normalizeEstadoName(est.ESTADO)),
  ) || null;

export const findSentToClientEstadoId = (tiposEstado = []) =>
  findSentToClientEstado(tiposEstado)?.ID_ESTADO ?? null;

export const findLeftWithClientEstado = (tiposEstado = []) =>
  tiposEstado.find((est) =>
    LEFT_WITH_CLIENT_ESTADO_NAMES.includes(normalizeEstadoName(est.ESTADO)),
  ) || null;

export const findLeftWithClientEstadoId = (tiposEstado = []) =>
  findLeftWithClientEstado(tiposEstado)?.ID_ESTADO ?? null;

export const findSentToSupplierEstado = (tiposEstado = []) =>
  tiposEstado.find((est) =>
    SENT_TO_SUPPLIER_ESTADO_NAMES.includes(normalizeEstadoName(est.ESTADO)),
  ) || null;

export const findSentToSupplierEstadoId = (tiposEstado = []) =>
  findSentToSupplierEstado(tiposEstado)?.ID_ESTADO ?? null;

export const findArrivedToClientEstado = (tiposEstado = []) =>
  tiposEstado.find((est) =>
    ARRIVED_TO_CLIENT_ESTADO_NAMES.includes(normalizeEstadoName(est.ESTADO)),
  ) || null;

export const findArrivedToClientEstadoId = (tiposEstado = []) =>
  findArrivedToClientEstado(tiposEstado)?.ID_ESTADO ?? null;

export const findArrivedToSupplierEstado = (tiposEstado = []) =>
  tiposEstado.find((est) =>
    ARRIVED_TO_SUPPLIER_ESTADO_NAMES.includes(normalizeEstadoName(est.ESTADO)),
  ) || null;

export const findArrivedToSupplierEstadoId = (tiposEstado = []) =>
  findArrivedToSupplierEstado(tiposEstado)?.ID_ESTADO ?? null;

export const SENT_ESTADO_ID = 5;
export const ARRIVED_SDS_ESTADO_ID = 8;

/** Clave i18n Samples.* para etiquetas de estado conocidas; null = usar texto BD. */
export const estadoLabelI18nKey = (estadoName = "") => {
  const normalized = normalizeEstadoName(estadoName);
  if (SENT_TO_CLIENT_ESTADO_NAMES.includes(normalized)) {
    return "Samples.estadoSentToClient";
  }
  if (SENT_TO_SUPPLIER_ESTADO_NAMES.includes(normalized)) {
    return "Samples.estadoSentToSupplier";
  }
  if (ARRIVED_TO_CLIENT_ESTADO_NAMES.includes(normalized)) {
    return "Samples.estadoArrivedToClient";
  }
  if (ARRIVED_TO_SUPPLIER_ESTADO_NAMES.includes(normalized)) {
    return "Samples.estadoArrivedToSupplier";
  }
  if (LEFT_WITH_CLIENT_ESTADO_NAMES.includes(normalized)) {
    return "Samples.estadoLeftWithClient";
  }
  if (normalized === "sent") return "Samples.estadoSent";
  if (normalized === "arrived") return "Samples.estadoArrived";
  return null;
};

export const formatEstadoLabel = (estadoName = "", t = null) => {
  const key = estadoLabelI18nKey(estadoName);
  if (key && typeof t === "function") {
    const translated = t(key);
    if (translated && translated !== key) return translated;
  }
  const normalized = normalizeEstadoName(estadoName);
  if (SENT_TO_CLIENT_ESTADO_NAMES.includes(normalized)) {
    return "Send to Client";
  }
  if (SENT_TO_SUPPLIER_ESTADO_NAMES.includes(normalized)) {
    return "Send to supplier";
  }
  if (ARRIVED_TO_CLIENT_ESTADO_NAMES.includes(normalized)) {
    return "ARRIVED TO CLIENT";
  }
  if (ARRIVED_TO_SUPPLIER_ESTADO_NAMES.includes(normalized)) {
    return "ARRIVED TO SUPPLIER";
  }
  if (LEFT_WITH_CLIENT_ESTADO_NAMES.includes(normalized)) {
    return "SE QUEDA EN CLIENTE";
  }
  if (normalized === "sent") return "SENT TO STAGE ES";
  if (normalized === "arrived") return "ARRIVED STAGE ES";
  return estadoName;
};

export const isArrivedSdsEstado = (estadoId, tiposEstado = []) => {
  const id = Number(estadoId);
  if (id === ARRIVED_SDS_ESTADO_ID) return true;
  const row = tiposEstado.find((est) => Number(est.ID_ESTADO) === id);
  return Boolean(
    row && ARRIVED_SDS_ESTADO_NAMES.includes(normalizeEstadoName(row.ESTADO)),
  );
};

export const isArrivedToClientEstado = (estadoId, tiposEstado = []) => {
  if (estadoId == null || estadoId === "") return false;
  const expected = findArrivedToClientEstadoId(tiposEstado);
  return expected != null && Number(estadoId) === Number(expected);
};

export const isArrivedToSupplierEstado = (estadoId, tiposEstado = []) => {
  if (estadoId == null || estadoId === "") return false;
  const expected = findArrivedToSupplierEstadoId(tiposEstado);
  return expected != null && Number(estadoId) === Number(expected);
};

/** ARRIVED SDS + Arrived to Client + Arrived to Supplier */
export const isArrivedEstado = (estadoId, tiposEstado = []) => {
  if (estadoId == null) return false;
  const id = Number(estadoId);
  if (
    isArrivedSdsEstado(id, tiposEstado) ||
    isArrivedToClientEstado(id, tiposEstado) ||
    isArrivedToSupplierEstado(id, tiposEstado)
  ) {
    return true;
  }
  // Fallback por id conocido si el catálogo aún no ha cargado
  return id === ARRIVED_SDS_ESTADO_ID || id === 13 || id === 14;
};

export const isArrivedEstadoName = (estadoName = "") => {
  const normalized = normalizeEstadoName(estadoName);
  return (
    ARRIVED_SDS_ESTADO_NAMES.includes(normalized) ||
    ARRIVED_TO_CLIENT_ESTADO_NAMES.includes(normalized) ||
    ARRIVED_TO_SUPPLIER_ESTADO_NAMES.includes(normalized)
  );
};

/**
 * Transiciones de recepción (cierran el envío, no lo borran).
 * SENT → ARRIVED | Sent to Client → Arrived to Client | Sent to Supplier → Arrived to Supplier
 */
export const isReceptionTransition = (
  fromEstadoId,
  toEstadoId,
  tiposEstado = [],
) => {
  if (fromEstadoId == null || toEstadoId == null) return false;
  const from = Number(fromEstadoId);
  const to = Number(toEstadoId);
  if (from === to) return false;

  if (from === SENT_ESTADO_ID && isArrivedSdsEstado(to, tiposEstado)) {
    return true;
  }
  if (
    isSentToClientEstado(from, tiposEstado) &&
    isArrivedToClientEstado(to, tiposEstado)
  ) {
    return true;
  }
  if (
    isSentToSupplierEstado(from, tiposEstado) &&
    isArrivedToSupplierEstado(to, tiposEstado)
  ) {
    return true;
  }
  // Fallbacks por id si el catálogo no ha cargado
  if (from === SENT_ESTADO_ID && to === ARRIVED_SDS_ESTADO_ID) return true;
  if (from === 11 && to === 13) return true;
  if (from === 12 && to === 14) return true;
  return false;
};

export const sortTiposEstadoForSelect = (tiposEstado = []) => {
  const sentToClient = findSentToClientEstado(tiposEstado);
  const leftWithClient = findLeftWithClientEstado(tiposEstado);
  const arrivedToClient = findArrivedToClientEstado(tiposEstado);
  const sentToSupplier = findSentToSupplierEstado(tiposEstado);
  const arrivedToSupplier = findArrivedToSupplierEstado(tiposEstado);
  const arrivedSds =
    tiposEstado.find((e) => isArrivedSdsEstado(e.ID_ESTADO, tiposEstado)) ||
    null;

  const specialIds = new Set(
    [
      sentToClient?.ID_ESTADO,
      leftWithClient?.ID_ESTADO,
      arrivedToClient?.ID_ESTADO,
      sentToSupplier?.ID_ESTADO,
      arrivedToSupplier?.ID_ESTADO,
      arrivedSds?.ID_ESTADO,
    ].filter((id) => id != null),
  );

  const rest = tiposEstado
    .filter((e) => !specialIds.has(e.ID_ESTADO))
    .sort((a, b) => a.ID_ESTADO - b.ID_ESTADO);

  const sentIndex = rest.findIndex(
    (e) =>
      e.ID_ESTADO === SENT_ESTADO_ID ||
      normalizeEstadoName(e.ESTADO) === "sent",
  );

  // SENT → ARRIVED (SDS) → Sent Client → Se queda en Cliente → Arrived Client → Supplier…
  const extras = [
    arrivedSds,
    sentToClient,
    leftWithClient,
    arrivedToClient,
    sentToSupplier,
    arrivedToSupplier,
  ].filter(Boolean);

  if (sentIndex === -1) {
    return [...rest, ...extras];
  }

  return [
    ...rest.slice(0, sentIndex + 1),
    ...extras,
    ...rest.slice(sentIndex + 1),
  ];
};

export const isSentToClientEstado = (estadoId, tiposEstado = []) => {
  if (estadoId == null || estadoId === "") return false;
  const expected = findSentToClientEstadoId(tiposEstado);
  return expected != null && Number(estadoId) === Number(expected);
};

export const isLeftWithClientEstado = (estadoId, tiposEstado = []) => {
  if (estadoId == null || estadoId === "") return false;
  const expected = findLeftWithClientEstadoId(tiposEstado);
  return expected != null && Number(estadoId) === Number(expected);
};

/** Sent to Client → Se queda en Cliente: convertir envío, no anularlo. */
export const isConvertSentToClientToLeftWithClient = (
  fromEstadoId,
  toEstadoId,
  tiposEstado = [],
) =>
  isSentToClientEstado(fromEstadoId, tiposEstado) &&
  isLeftWithClientEstado(toEstadoId, tiposEstado);

export const isSentToSupplierEstado = (estadoId, tiposEstado = []) => {
  if (estadoId == null || estadoId === "") return false;
  const expected = findSentToSupplierEstadoId(tiposEstado);
  return expected != null && Number(estadoId) === Number(expected);
};

/** OK FACTORY / SENT — solo proveedores (China) pueden seleccionarlos. */
export const isChinaOnlyEstado = (estadoId) => estadoId === 3 || estadoId === 5;

/** Estados que un proveedor puede elegir en el select. */
export const isProviderSelectableEstado = (estadoId, tiposEstado = []) =>
  isChinaOnlyEstado(estadoId) ||
  isSentToClientEstado(estadoId, tiposEstado) ||
  isSentToSupplierEstado(estadoId, tiposEstado) ||
  isLeftWithClientEstado(estadoId, tiposEstado);

/**
 * Enviado a cliente/proveedor: no crear otro envío hasta recepción
 * o hasta que un supervisor anule el envío.
 * SENT (China→SDS) no bloquea: aún puede pasar a Sent to Client/Supplier.
 */
export const blocksNewShipmentUntilReception = (
  estadoId,
  tiposEstado = [],
  estadoNombre = null,
) => {
  if (isShipmentEstadoNameBlocking(estadoNombre)) return true;
  if (
    isSentToClientEstado(estadoId, tiposEstado) ||
    isSentToSupplierEstado(estadoId, tiposEstado)
  ) {
    return true;
  }
  // Fallback por id conocido (por si el catálogo aún no ha cargado)
  const id = Number(estadoId);
  return id === 11 || id === 12;
};

export const isShipmentEstadoNameBlocking = (estadoName = "") => {
  const normalized = normalizeEstadoName(estadoName);
  return (
    SENT_TO_CLIENT_ESTADO_NAMES.includes(normalized) ||
    SENT_TO_SUPPLIER_ESTADO_NAMES.includes(normalized)
  );
};

/**
 * Enviado y aún no recepcionado: SENT (China→SDS), Sent to Client, Sent to Supplier.
 * Se usa para cabecera naranja.
 */
export const isShippedPendingReceptionEstado = (estadoId, tiposEstado = []) => {
  if (estadoId == null) return false;
  const id = Number(estadoId);
  if (id === SENT_ESTADO_ID) return true;
  return blocksNewShipmentUntilReception(id, tiposEstado);
};

/** China debe indicar Nº Courier al crear el envío. Sitges lo deja para Guillermo. */
export const requiresCourierOnShipment = ({ isChinaUser = false } = {}) =>
  Boolean(isChinaUser);

export const resolveShipmentDialogMode = (estadoId, tiposEstado = []) => {
  if (Number(estadoId) === SENT_ESTADO_ID) return "sent";
  if (isSentToSupplierEstado(estadoId, tiposEstado)) return "sentToSupplier";
  if (isLeftWithClientEstado(estadoId, tiposEstado)) return "leftWithClient";
  if (isSentToClientEstado(estadoId, tiposEstado)) return "sentToClient";
  return null;
};

/** Cualquier arrived permanece bloqueada salvo el color, que puede corregirse.
 * Ver isArrivedHardLocked (solo admin puede editar el resto).
 */
export const applyGeneralEditForArrived = (
  previous,
  updated,
  tiposEstado = [],
  options = {},
) => {
  if (
    !isArrivedHardLocked(previous?.ID_ESTADO, tiposEstado, {
      isAdmin: options.isAdmin,
      movimientos: options.movimientos,
    })
  ) {
    return updated;
  }
  return {
    ...previous,
    ID_COLOR_BASE: updated?.ID_COLOR_BASE ?? previous.ID_COLOR_BASE,
  };
};

const normalizeMarcaName = (value = "") => String(value).trim().toUpperCase();

/** Internal destinations (warehouse / SDS) — not "Sent to Client". */
export const isInternalShipmentMarca = (marcaName = "") => {
  const normalized = normalizeMarcaName(marcaName);
  if (!normalized) return false;
  return normalized.includes("STAGE DESIGN") || normalized === "SDS";
};

export const findSdsMarca = (tiposMarcas = []) => {
  const list = Array.isArray(tiposMarcas) ? tiposMarcas : [];
  const exactSds = list.find((m) => normalizeMarcaName(m.MARCA) === "SDS");
  if (exactSds) return exactSds;
  return list.find((m) => isInternalShipmentMarca(m.MARCA)) || null;
};

export const findSdsMarcaId = (tiposMarcas = []) =>
  findSdsMarca(tiposMarcas)?.ID_MARCA ?? null;

export const getMarcaNameById = (idMarca, tiposMarcas = []) => {
  const marca = tiposMarcas.find((m) => Number(m.ID_MARCA) === Number(idMarca));
  return marca?.MARCA || "";
};

export const pickLatestMovimiento = (movimientos = []) =>
  [...movimientos]
    .filter(
      (m) =>
        m.FECHA_ENVIO &&
        (m.TIPO_DESTINO || m.ID_Marca || m.ID_CLIENTE || m.CODPROV),
    )
    .sort((a, b) => {
      const ta = new Date(a.FECHA_ENVIO).getTime();
      const tb = new Date(b.FECHA_ENVIO).getTime();
      if (tb !== ta) return tb - ta;
      return (b.ID_MOVIMIENTO || 0) - (a.ID_MOVIMIENTO || 0);
    })[0] || null;

export const shouldSetSentToClientFromMovimientos = (
  movimientos,
  tiposMarcas = [],
) => {
  const latest = pickLatestMovimiento(movimientos);
  if (!latest) return false;

  const tipo = String(latest.TIPO_DESTINO || "").toUpperCase();
  if (tipo === "CLIENTE") return true;
  if (tipo === "PROVEEDOR" || tipo === "INTERNO") return false;

  // Legacy marca-based destination
  const marcaName = getMarcaNameById(latest.ID_Marca, tiposMarcas);
  return marcaName && !isInternalShipmentMarca(marcaName);
};

export const shouldSetSentToSupplierFromMovimientos = (movimientos = []) => {
  const latest = pickLatestMovimiento(movimientos);
  if (!latest) return false;
  return String(latest.TIPO_DESTINO || "").toUpperCase() === "PROVEEDOR";
};

/** Movimientos de envío real (no solo marca legacy) a borrar al revertir estado. */
export const isShipmentMovimiento = (mov = {}) => {
  const tipo = String(mov.TIPO_DESTINO || "").toUpperCase();
  return (
    tipo === "CLIENTE" ||
    tipo === "PROVEEDOR" ||
    tipo === "INTERNO" ||
    Boolean(mov.IdCourierControl)
  );
};

export const hasShipmentMovimientos = (movimientos = []) =>
  (Array.isArray(movimientos) ? movimientos : []).some(isShipmentMovimiento);

/**
 * Bloqueo duro ARRIVED: solo color.
 * No aplica a admin. Una vez llegada, no hay marcha atrás (tampoco el legado sin envíos).
 * Si no se pasan movimientos, se mantiene el bloqueo (comportamiento seguro).
 */
export const isArrivedHardLocked = (
  estadoId,
  tiposEstado = [],
  { isAdmin = false, movimientos = undefined } = {},
) => {
  if (!isArrivedEstado(estadoId, tiposEstado)) return false;
  if (isAdmin) return false;
  return true;
};

/**
 * ¿Hay que crear un envío China→SDS al marcar ARRIVED sin SENT previo?
 * Si ya es recepción (SENT→ARRIVED) o ya hay movimientos de envío, no.
 */
export const shouldCreateSyntheticSdsArrival = (
  fromEstadoId,
  toEstadoId,
  movimientos = [],
  tiposEstado = [],
) => {
  if (!isArrivedSdsEstado(toEstadoId, tiposEstado)) return false;
  if (isReceptionTransition(fromEstadoId, toEstadoId, tiposEstado)) {
    return false;
  }
  if (hasShipmentMovimientos(movimientos)) return false;
  return true;
};

export const applyMuestraFromMovimientos = ({
  movimientos,
  tiposMarcas,
  sentToClientEstadoId,
  sentToSupplierEstadoId,
  setMuestra,
}) => {
  const fechasValidas = movimientos.map((m) => m.FECHA_ENVIO).filter(Boolean);

  setMuestra((prev) => {
    const next = { ...prev };

    if (fechasValidas.length === 0) {
      next.FECHA_ENVIO = null;
    } else {
      next.FECHA_ENVIO = fechasValidas.sort()[0];
    }

    if (
      sentToSupplierEstadoId &&
      shouldSetSentToSupplierFromMovimientos(movimientos)
    ) {
      next.ID_ESTADO = sentToSupplierEstadoId;
    } else if (
      sentToClientEstadoId &&
      shouldSetSentToClientFromMovimientos(movimientos, tiposMarcas)
    ) {
      next.ID_ESTADO = sentToClientEstadoId;
    }

    return next;
  });
};
